import React from 'react';
import { User, BookOpen, Flag } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-261">
      <div className="max-w-4xl mx-auto" data-id="element-262">
        <div className="text-center mb-12" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-264">
            The Legacy Archive Framework
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-265">
            A simple 3-part way to experience Charlie's story so it actually
            sticks: the man, the moments, and the meaning.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-266">
          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-navy text-center" data-id="element-267">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-268">
              <User className="text-navy" size={32} data-id="element-269" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-270">The Man</h3>
            <p className="text-gray-600 text-sm" data-id="element-271">
              Understand the upbringing, mindset, and personal traits that
              shaped Charlie before the spotlight.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-patriot-red text-center transform md:-translate-y-4" data-id="element-272">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-273">
              <BookOpen className="text-patriot-red" size={32} data-id="element-274" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-275">The Moments</h3>
            <p className="text-gray-600 text-sm" data-id="element-276">
              The defining turning points—key events, controversies, and
              breakthroughs that built the legacy.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-gold text-center" data-id="element-277">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-278">
              <Flag className="text-gold" size={32} data-id="element-279" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-280">The Legacy</h3>
            <p className="text-gray-600 text-sm" data-id="element-281">
              The ideas, quotes, and principles people will remember—and how to
              pass them on.
            </p>
          </div>
        </div>

        <div className="bg-navy text-white p-8 rounded-xl text-center shadow-lg" data-id="element-282">
          <p className="text-lg md:text-xl font-medium italic" data-id="element-283">
            "This isn't about worshipping a personality. It's about preserving a
            modern American story worth remembering."
          </p>
        </div>
      </div>
    </section>;
}